<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div style="text-align: center">
            <state-filter
              v-model="filter.state_id"
              :allowedStates="[1, 2, 3, 4, 5]"
            />
          </div>
          <div class="d-flex flex-column flex-md-row justify-content-between">
            <date-filter v-model="filter.date" class="my-3" />
            <div class="d-flex flex-column flex-md-row mt-3 mt-md-0 k-gap-3">
              <bita-filtersbutton
                icon="fas fa-filter"
                :title="filterTitle"
                @click="toggleFilters"
              />
              <bita-filtersbutton
                icon="fas fa-print"
                title="چاپ"
                @click="print"
              />
              <bita-filtersbutton
                v-if="$acl.can('print', 'cargoes')"
                icon="fas fa-print"
                title="بارنامه های قابل صدور"
                @click="printAllCargoes"
              />
            </div>
          </div>

          <br />
          <transition name="fade">
            <div v-show="showFilters">
              <bita-form ref="form">
                <div slot="body">
                  <div class="row">
                    <bita-select
                      ref="statesDropDown"
                      name="states"
                      label="وضعیت"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="states"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.state_id"
                    />
                    <bita-datepicker
                      type="date"
                      id="fromDate"
                      validation-container-class="col-lg-2"
                      name="from-date"
                      label="از تاریخ"
                      inputClass="form-control"
                      v-model="filter.fromDate"
                    />
                    <bita-datepicker
                      type="date"
                      id="toDate"
                      validation-container-class="col-lg-2"
                      name="to-date"
                      label="تا تاریخ"
                      inputClass="form-control"
                      v-model="filter.toDate"
                    />
                    <bita-select
                      name="state"
                      label="استان مبدا"
                      ref="originStateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.origin_province_id"
                      @change="(e) => this.getCityOrgin(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesOrgin"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesOrgin === false"
                      name="citiesOrgin"
                      label="شهر مبدا"
                      ref="citiesOrginDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesOrgin"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.origin_city_id"
                    />

                    <bita-select
                      name="state"
                      label="استان مقصد"
                      ref="destinationstateDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="state"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.destination_province_id"
                      @change="(e) => this.getCityDestination(e)"
                    />

                    <bita-spinner
                      :is-loading="isLoadingCitiesDestination"
                      class-name="col-lg-2"
                      styleName="align-self: center;"
                    />

                    <bita-select
                      v-if="this.isLoadingCitiesDestination === false"
                      name="citiesDestination"
                      label="شهر مقصد"
                      ref="citiesDestinationDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="citiesDestination"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.destination_city_id"
                    />
                    <bita-select
                      name="vehicle_types"
                      label="نوع ماشین"
                      ref="vehicleTypesDropDown"
                      rules
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="vehicleTypes"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.vehicle_type_id"
                    />
                    <bita-input
                      type="text"
                      name="national_code"
                      label="کدملی راننده"
                      rules="required|irani"
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      v-model.lazy="driver_national_code"
                      @change="findDriver"
                      subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
                    />
                    <bita-input
                      type="text"
                      name="tracking_code"
                      label="کد پیگیری"
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      @change="(e) => findTrackingCode(e)"
                      subtitle=" کد پیگیری را بدون پیشوند وارد نمایید.(تنها اعداد مثلا: ۱۲۳−۱۲۳۴۵۶)"
                    />
                    <bita-select
                      name="salon"
                      label="سالن"
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="salons"
                      data-text-field="name"
                      data-value-field="id"
                      v-model="filter.salon_id"
                    />
                    <bita-select
                      type="created_by"
                      name="created_by"
                      label="ایجاد کننده"
                      validation-container-class="col-lg-2"
                      input-class="form-control"
                      :data-source="users"
                      data-text-field="full_name"
                      data-value-field="id"
                      v-model="filter.created_by"
                    />
                  </div>
                </div>
              </bita-form>
            </div>
          </transition>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :resizable="true"
            :on-data-binding="onDataBinding"
            :grid-server-side="true"
            :server-paging="true"
            :batch="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal-status
      modal-id="edit-modal"
      title="ویرایش"
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateFormStatus"
      @on-submit="handleEditStatus"
    />
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :drivers="drivers"
      modal-id="edit-modal"
      title="انتصاب راننده"
      @on-submit="handleEdit"
    />
    <checkout-modal
      modal-id="checkout-modal"
      :title="`ترخیص بار`"
      :propsData="updateForm"
      :category-loads="parentLoads"
      :customers="customers"
      :is-loading="isLoadingModal"
      @on-submit="(e) => checkout(e)"
    />
    <driver-info-modal
      ref="driverInfo"
      modal-id="driver-info-modal"
      :title="`اطلاعات راننده`"
      :is-loading="isLoadingModal"
    />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: requestDetail}">
      <g-list>
        <g-list-item
          v-if="$acl.can('update', 'requestsmanagements')"
          title="انتصاب راننده"
          icon="fas fa-user-plus"
          @click="edit(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('update', 'requestsmanagements')"
          title="ویرایش وضعیت بار"
          icon="fas fa-pen-square"
          @click="editStatus(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('print', 'cargoes')"
          title="جزئیات بار"
          icon="fas fa-info"
          @click="showDriverInfo(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('delete', 'requestsmanagements')"
          title="حذف"
          icon="fas fa-times"
          @click="deleteRequest(requestDetail)"
        />
        <g-list-item
          v-if="$acl.can('update', 'requestsmanagements')"
          title="تغییر وضعیت"
          icon="fas fa-lock"
          @click="status(requestDetail)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import Form from "./Form";
import DateFilter from "./../../components/DateFilter";
import StateFilter from "./../../components/StateFilter";
import CheckoutModal from "./components/CheckoutModal";
import DriverInfoModal from "./components/DriverInfoModal";
import RequestDetailForm from "../management/request-detail/Form.vue";
import GContextMenu from "../../components/GContextMenu.vue";
import GList from "../../components/listItem/GList.vue";
import GListItem from "../../components/listItem/GListItem.vue";

export default {
  components: {
    "form-modal": Form,
    "form-modal-status": RequestDetailForm,
    DateFilter,
    StateFilter,
    CheckoutModal,
    DriverInfoModal,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      salons: [],
      users: [],
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "کارتابل", link: "/management/requests", active: true },
      ],
      isLoadingModal: false,
      isLoadingGrid: false,
      showFilters: false,
      isLoadingCitiesOrgin: false,
      isLoadingCitiesDestination: false,
      updateForm: {
        driver_id: 0,
      },
      updateFormStatus: {
        driver_id: 0,
      },
      filter: {
        date: this.$getJalaliDate(null, "YYYY-MM-DD"),
        created_by: "",
      },
      requests: {},
      drivers: [],
      customers: [],
      states: [],
      state: [],
      citiesOrgin: [],
      citiesDestination: [],
      vehicleTypes: [],
      pageSize: 30,
      currentPage: 1,
      driver_national_code: "",
      parentLoads: [],
    };
  },
  computed: {
    filterTitle() {
      return this.showFilters ? "حذف فیلتر" : "فیلتر بیشتر";
    },
    gridColumns() {
      let cols = [
        {
          field: "tracking_code",
          title: "کد",
          width: "90px",
          template: (e) => (e.tracking_code ? e.tracking_code : " - "),
        },
        {
          field: "request.origin",
          title: "مبدا",
          template: (e) =>
            e.request && e.request.origin
              ? `${e.request.origin.province.name}/${e.request.origin.name}`
              : " - ",
          width: "100px",
        },
        {
          field: "request.destination",
          title: "مقصد",
          template: (e) =>
            e.request && e.request.destination
              ? `${e.request.destination.province.name}/${e.request.destination.name}`
              : " - ",
          width: "100px",
        },
        {
          field: "request.tonnage",
          title: "تناژ",
          width: "60px",
          template: (e) =>
            e.request && e.request.tonnage ? `${e.request?.tonnage}` : " - ",
          width: "100px",
        },
        {
          field: "request.vehicle_types",
          title: "نوع ماشین",
          template: (e) =>
            e.request && e.request.vehicle_type?.name
              ? e.request.vehicle_type?.name
              : "-",
          width: "100px",
        },
        {
          field: "price",
          title: this.$currencyLabel("قیمت بر تناژ"),
          template: (e) =>
            e.price
              ? this.$thousandSeprator(
                  this.$round(e.price / e.request?.tonnage, 0),
                )
              : " - ",
          width: "100px",
        },
        {
          field: "net_price",
          title: this.$currencyLabel("قیمت صافی بر تناژ"),
          template: (e) =>
            e.net_price
              ? this.$thousandSeprator(
                  this.$round(e.net_price / e.request?.tonnage, 0),
                )
              : " - ",
          width: "100px",
        },
        {
          field: "request.loading_at",
          title: "بارگیری",
          width: "90px",
          template: (e) =>
            e.request && e.request.loading_at
              ? `${this.$getJalaliDate(e.request.loading_at)}`
              : " - ",
          width: "100px",
        },
        {
          field: "request.delivery_at",
          title: "تحویل",
          width: "90px",
          template: (e) =>
            e.request && e.request.delivery_at
              ? `${this.$getJalaliDate(e.request.delivery_at)}`
              : " - ",
          width: "100px",
        },
        {
          field: "parent_item",
          title: "راننده",
          template: (e) =>
            e.request_ticket ? `${e.request_ticket.driver?.full_name}` : " - ",
          width: "100px",
        },
        {
          field: "attend_time",
          title: "زمان مراجعه",
          width: "100px",
        },
        // {
        //   field: "created_at",
        //   title: "تاریخ ایجاد",
        //   template: (e) =>
        //     e.created_at ? this.$getJalaliDateTimeShort(e.created_at) : " - ",
        // },
        // {
        //   field: "updated_at",
        //   title: "آخرین انقضا",
        //   template: (e) =>
        //     e.request && e.request.expired_at
        //       ? this.$getJalaliDateFromDateTime(e.request.expired_at)
        //       : " - ",
        // },
        {
          field: "state_text",
          title: "وضعیت",
          template: (e) => (e.state && e.state.name ? e.state.name : " - "),
          width: "100px",
        },
      ];
      if (this.$acl.isCarrier)
        cols.push({
          field: "owner",
          title: "صاحب بار",
          template: (e) => (e.owner ? `${e.owner.name}` : " - "),
          width: "100px",
        });
      if (this.$acl.isOwner) {
        cols.push({
          field: "carrier",
          title: "باربری",
          template: (e) =>
            e.carrier && e.carrier.user
              ? `${e.carrier.user.name}  ${e.carrier.user.family}`
              : " - ",
          width: "100px",
        });
        cols.push({
          field: "customer",
          title: "مشتری",
          template: (e) => (e.customer ? `${e.customer.full_name}` : " - "),
          width: "100px",
        });
      }
      if (this.gridCommands().length)
        cols.push({
          title: "عملیات",
          command: this.gridCommands(),
          width: 50,
        });
      return cols;
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.isLoadingGrid = true;

    Promise.all([
      // this.getDrivers(),
      this.getStates(),
      this.getState(),
      this.getVehicleTypes(),
      this.getLoads(0),
      this.getSalons(),
      this.getUsers(),
    ]).then((res) => {
      // this.drivers = res[0].data;
      this.states = res[0].data;
      this.state = res[1].data;
      this.vehicleTypes = res[2].data;
      this.parentLoads = res[3].data;
      this.salons = res[4].data;
      this.users = res[5].data;
      // this.isLoadingGrid = false;
    });
    // this.getDrivers();
    // this.getRequests();
    // this.loadData();
  },
  methods: {
    search: function() {
      this.loadData();
    },
    getUsers() {
      return this.$persistClient("get", `requests/users`);
    },
    showDriverInfo(requestDetail) {
      this.$refs.driverInfo.init({ requestDetail });

      this.$toggleModal("#driver-info-modal");
    },
    print() {
      this.$print("reports/export-rd1", this.filter);
    },
    printAllCargoes() {
      this.$print("reports/export-cr1");
    },
    getState() {
      return this.$persistClient("get", "cities?filter[province]=0");
    },
    getVehicleTypes() {
      return this.$persistClient("get", "vehicle-types");
    },
    getCityOrgin(stateId) {
      this.isLoadingCitiesOrgin = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesOrgin = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesOrgin = false;
        });
    },
    getCityDestination(stateId) {
      this.isLoadingCitiesDestination = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesDestination = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesDestination = false;
        });
    },
    getStates() {
      return this.$persistClient("get", "states?type=requestdetail");
    },
    getSalons() {
      return this.$persistClient("get", "management/salons");
    },
    resetFilters() {
      let dropDowns = [
        "statesDropDown",
        "carrierDropDown",
        "originStateDropDown",
        "citiesOrginDropDown",
        "destinationstateDropDown",
        "citiesDestination",
      ];
      for (let ref of dropDowns) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filter = {};
        this.resetFilters();
        this.loadData();
      }
    },
    onDataBinding: function(ev) {
      var vm = this;
      setTimeout(() => {
        var grid = $("#grid").data("kendoGrid");
        var items = ev.items;
        items.forEach(function(item) {
          var dataItem = item;
          var selector = $(`.k-master-row[data-uid=${item.uid}]`);
          if (dataItem.state.color && !vm.filter.state_id) {
            selector.css("background-color", `#${dataItem.state.color}`);
            selector.css("color", `${vm.$findBgColor(dataItem.state.color)}`);
          }
        });
      }, 1000);
      // this.record =
      //   (this.currentPage - 1) * this.pageSize;
      var grid = this.$refs.grid.onDataBindingLocal();
      // this.report.review == 2 ? grid.hideColumn(10) : "";
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;

      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `request-details?sort=attend_time&include=carrier,driver.user,user,state,request.origin,request.destination,request.loadData,request.vehicleType,request.loadingTime,owner,requestTicket.driver&page-size=30&page=${this.currentPage}&page_size=${this.pageSize}`;
      if (this.$acl.isOwner)
        baseUrl = `request-details?sort=attend_time&include=carrier,driver.user,user,state,request.origin,request.destination,request.loadData,request.vehicleType,request.loadingTime,customer,requestTicket.driver&page-size=30&page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filter, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch((res) => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      this.$toggleModal("#edit-modal");
    },
    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    editStatus(requestDetail) {
      this.updateFormStatus = {
        id: requestDetail.id,
      };

      this.statusChangeModalEditStatus();
    },
    statusChangeModalEditStatus() {
      this.$toggleModal("#edit-modal");
    },
    handleEditStatus(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `request-details/${data.id}/states`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            state_id: 0,
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    status(requestDetail) {
      if (requestDetail.state.id != 4) {
        this.$izitoast(
          "error",
          "ناموفق",
          "شما دسترسی به تغییر وضعیت این بار را ندارید",
        );
        return;
      }

      this.$alert("question", `آیا از تغییر وضعیت این بار اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          let status = {
            state_id: 5,
          };
          this.$persistClient(
            "patch",
            `request-details/${requestDetail.id}/states`,
            status,
          )
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    openCheckoutModal(e) {
      this.$toggleModal("#checkout-modal");
      this.isLoadingModal = true;
      let checkoutable = this.$refs.grid.getSelectedGridRow(e);
      this.$persistClient(
        "get",
        `request-details/${checkoutable.id}/checkoutable`,
      )
        .then((res) => {
          if (res.data && res.data[0]) this.updateForm = res.data[0];
          else this.updateForm = {};
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    printCargo(e) {
      let requestDetail = this.$refs.grid.getSelectedGridRow(e);
      /*
      if (!requestDetail.cargo_state) {
        this.$alert("error", "خطا", "درخواست در مرحله صدور بارنامه نمی‌باشد");
        return;
      }
*/
      let q = { request_detail: requestDetail.id };
      this.$print("reports/export-cargo", q);
    },
    edit(requestDetail) {
      this.updateForm = {
        request_id: requestDetail.request_id,
        request_type: requestDetail.request.request_type,
        id: requestDetail.id,
        driver_id: requestDetail.driver_id,
        amount_payable: requestDetail.amount_payable,
        driver_name:
          requestDetail.driver && requestDetail.driver.user
            ? `${requestDetail.driver.user.name} ${requestDetail.driver.user.family}`
            : "",
        driver_national_code:
          requestDetail.driver && requestDetail.driver.user
            ? requestDetail.driver.user.national_code
            : "",
        // customer_id: requestDetail.customer_id,
        // price: requestDetail.price ? requestDetail.price : '',
        // net_price: requestDetail.net_price ? requestDetail.net_price : '',
      };

      this.statusChangeModalEdit();
    },
    deleteRequest(requestDetail) {
      this.$alert(
        "question",
        `آیا از حذف ${requestDetail.tracking_code} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `request-details/${requestDetail.id}`)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    getRequests() {
      return this.$persistClient("get", `requests/${this.$route.params.id}`);
    },
    getDrivers() {
      return this.$persistClient("get", `drivers?include=user`);
    },
    getCustomers() {
      return this.$persistClient("get", "customers");
    },
    handleEdit(data) {
      if (data.purchase_with == 2) {
        let text =
          this.updateForm.request_type == 1
            ? `در صورت تایید مبلغ ${this.$thousandSeprator(
                data.amount_payable,
              )} ${this.$cashUnit} از حساب شما کسر خواهد شد.`
            : `از ثبت این بار برای خود مطمئن هستید ؟`;
        this.$alert("question", text, "", {
          confirmButtonText: "بله",
        }).then((result) => {
          if (result.value) {
            this.loadData();
            this.approveRequestDetail(data);
          }
        });
      } else {
        this.approveRequestDetail(data);
      }
    },
    approveRequestDetail(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `request-details/${data.id}/assign`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            driver_id: 0,
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
          this.$root.$emit("update:balance");
        })
        .catch((res) => {
          this.updateForm = {
            driver_id: 0,
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    findDriver() {
      if (this.$ssnIsValid(this.driver_national_code)) {
        this.$persistClient("post", `drivers/national-code`, {
          national_code: this.driver_national_code,
        })
          .then((res) => {
            if (res.data.is_success) {
              this.filter = {
                driver_id: res.data.data?.model?.id,
              };
            }
          })
          .catch((res) => {
            this.filter = {
              driver_id: "",
            };
          });
      }
    },
    getLoads(categoryId) {
      return this.$persistClient(
        "get",
        `loads?filter[parentItem]=${categoryId}`,
      );
    },
    findTrackingCode(e) {
      if (e.length == 10)
        this.filter = {
          tracking_code: e,
        };
      else if (e == "")
        this.filter = {
          tracking_code: "",
        };
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
<style>
.status-paymentwaiting {
  background-color: #d7d005 !important;
}
.status-reserved {
  background-color: #000087 !important;
}
</style>
